import * as React from 'react';
export const IcInternetHighSpeed = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16 14a1 1 0 00-.71.29A1 1 0 0015 15v3.59l-.29-.3A1 1 0 0014 18a1 1 0 00-.71 1.71l2 2a1 1 0 00.32.22c.125.047.257.071.39.07a.84.84 0 00.38-.08 1 1 0 00.45-.37A1 1 0 0017 21v-6a1 1 0 00-.29-.71A1.05 1.05 0 0016 14zm5.71 2.29l-2-2a1 1 0 00-.52-.27.93.93 0 00-.57.06 1 1 0 00-.45.37A1 1 0 0018 15v6a1 1 0 00.29.71A1 1 0 0019 22a1.05 1.05 0 00.71-.29A1 1 0 0020 21v-3.59l.29.3A1 1 0 0021 18a1 1 0 00.71-1.71zM11 19.46A7.93 7.93 0 019.45 16H13v-1c0-.341.06-.68.18-1H9.11a17.83 17.83 0 010-4h5.78c.072.664.108 1.332.11 2v.19a2.8 2.8 0 012 0V12a14.51 14.51 0 00-.09-2h2.83c.166.654.254 1.325.26 2v.18c.427.14.814.38 1.13.7l.74.73A10 10 0 1012 22h.72l-.84-.88a2.91 2.91 0 01-.88-1.66zM18.92 8h-2.31a12.85 12.85 0 00-1-3.15A8.1 8.1 0 0118.92 8zM12 4c.84 0 1.95 1.48 2.55 4h-5.1c.6-2.52 1.71-4 2.55-4zm-7.74 6h2.83A14.51 14.51 0 007 12a14.51 14.51 0 00.09 2H4.26a7.75 7.75 0 010-4zm.82 6h2.31a12.43 12.43 0 001 3.15A8.1 8.1 0 015.08 16zm2.31-8H5.08a8.1 8.1 0 013.36-3.15A12.55 12.55 0 007.39 8z'
      fill='currentColor'
    />
  </svg>
);
